import React, { useState } from "react";
import HeroImage from "../../assets/img/portfolio/Purva&Raghav/Purva&RaghavBigBanner.webp";

import gallery from "../../assets/img/bg/weiding-bg.webp";

const PurvaRaghav = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  // Define your image paths here
  const images = {
    portfolio1: require("../../assets/img/portfolio/Purva&Raghav/1.webp"),
    portfolio2: require("../../assets/img/portfolio/Purva&Raghav/2.webp"),
    portfolio3: require("../../assets/img/portfolio/Purva&Raghav/3.webp"),
    portfolio4: require("../../assets/img/portfolio/Purva&Raghav/4.webp"),
    portfolio5: require("../../assets/img/portfolio/Purva&Raghav/5.webp"),
    portfolio6: require("../../assets/img/portfolio/Purva&Raghav/6.webp"),
    portfolio7: require("../../assets/img/portfolio/Purva&Raghav/7.webp"),
    portfolio8: require("../../assets/img/portfolio/Purva&Raghav/8.webp"),
    portfolio9: require("../../assets/img/portfolio/Purva&Raghav/9.webp"),
    portfolio10: require("../../assets/img/portfolio/Purva&Raghav/10.webp"),
    portfolio11: require("../../assets/img/portfolio/Purva&Raghav/11.webp"),
    portfolio12: require("../../assets/img/portfolio/Purva&Raghav/12.webp"),
    portfolio13: require("../../assets/img/portfolio/Purva&Raghav/13.webp"),
    portfolio14: require("../../assets/img/portfolio/Purva&Raghav/14.webp"),
    portfolio15: require("../../assets/img/portfolio/Purva&Raghav/15.webp"),
    portfolio16: require("../../assets/img/portfolio/Purva&Raghav/16.webp"),
    portfolio17: require("../../assets/img/portfolio/Purva&Raghav/17.webp"),
    portfolio18: require("../../assets/img/portfolio/Purva&Raghav/18.webp"),
    portfolio19: require("../../assets/img/portfolio/Purva&Raghav/19.webp"),
    portfolio20: require("../../assets/img/portfolio/Purva&Raghav/20.webp"),
    portfolio21: require("../../assets/img/portfolio/Purva&Raghav/21.webp"),
    portfolio22: require("../../assets/img/portfolio/Purva&Raghav/22.webp"),
  };

  // Function to handle image click: opens the modal with the selected image
  const openModal = (imageKey) => {
    setSelectedImage(images[imageKey]);
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const containerStyle = {
    background: `url(${HeroImage}) top/cover no-repeat`,
    backgroundColor: "#1C242970", // This sets a semi-transparent overlay color
    height: "60vh",
  };

  return (
    <div>
      <div
        style={containerStyle}
        className="flex  items-center justify-center relative -z-[900] "
      >
        <div className="absolute inset-0 bg-[#0000007f] z-0"></div>

        <h2 className="text-white text-center text-[60px] z-0">
          Purva & Raghav
        </h2>
      </div>

      <div class="flex flex-col lg:flex-row justify-center gap-10 lg:px-10 px-2 py-10">
        <div class="lg:w-[500px]">
          <div class="lv-portfolio-details-top-wrap-1-4 mb-35">
            <h4 class="lv-portfolio-details-title-1-4 text-[#000066]">
              Purva & Raghav
            </h4>

            <span class="lv-portfolio-date-1-4">
              December 2024, ITC Maratha, Mumbai
            </span>
          </div>
          <div class="lv-portfolio-details-content-1-4 mb-30">
            <h2>A Wedding That Felt Like Coming Home</h2>
            <p class="mb-25">
              When Purva & Raghav reached out to us, they had one goal—to bring
              their love story back home. Living in the US, they wanted their
              wedding in Mumbai to be a heartfelt celebration of their
              Maharashtrian and Bengali roots. We were honored to design and
              execute an experience that blended their cultures seamlessly.
            </p>
            <h3>An Intimate & Joyful Start in Vasai</h3>
            <p class="mb-25">
              The festivities began at a beautiful lawn near the bride’s home in
              Vasai, where the Haldi & Sangeet were bursting with energy and
              vibrant décor. From a playful Haldi ceremony drenched in turmeric
              hues to a Sangeet night filled with music and dance, every moment
              was crafted to reflect the joy of their union.
            </p>
            <h3>A Grand Celebration at ITC Maratha</h3>
            <p class="mb-25">
              For the wedding day, we transformed ITC Maratha into a regal space
              that captured the essence of both Maharashtrian and Bengali
              traditions. The décor was an elegant mix of classic red-and- gold
              tones, intricate floral arrangements, and meaningful elements from
              both cultures. As the couple exchanged vows surrounded by their
              loved ones, it was a moment that felt truly magical.
            </p>
            <h3>A Wedding to Remember</h3>
            <p class="mb-25">
              Watching Purva & Raghav celebrate their love with their closest
              friends and family was incredibly special for us. Every detail,
              from the pre-wedding rituals to the grand ceremony, was curated
              with care to ensure their wedding felt intimate, personal, and
              unforgettable.
            </p>
          </div>
        </div>

        <div className="lg:w-[600px]">
          {/* Mapping other images, assuming similar behavior for simplicity */}
          <div className="py-3">
            <img
              className=""
              src={require("../../assets/img/portfolio/Purva&Raghav/16.webp")}
            />
          </div>
          <div className="flex gap-3 flex-col lg:flex-row ">
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio1"]})`,
              }}
            ></div>
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio2"]})`,
              }}
            ></div>
          </div>
          <div className="flex gap-3 flex-col lg:flex-row  py-3">
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio3"]})`,
              }}
            ></div>
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-top-center"
              style={{
                backgroundImage: `url(${images["portfolio4"]})`,
              }}
            ></div>
          </div>
          <div className="flex gap-3 flex-col lg:flex-row  py-3">
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio5"]})`,
              }}
            ></div>
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-top-center"
              style={{
                backgroundImage: `url(${images["portfolio6"]})`,
              }}
            ></div>
          </div>
          <div className="flex gap-3 flex-col lg:flex-row  py-3">
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio7"]})`,
              }}
            ></div>
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-top-center"
              style={{
                backgroundImage: `url(${images["portfolio8"]})`,
              }}
            ></div>
          </div>
          <div className="flex gap-3 flex-col lg:flex-row  py-3">
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-no-repeat  bg-right-top"
              style={{
                backgroundImage: `url(${images["portfolio9"]})`,
              }}
            ></div>
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio10"]})`,
              }}
            ></div>
          </div>
          <div className="flex gap-3 flex-col lg:flex-row  py-3">
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio11"]})`,
              }}
            ></div>
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-top-center"
              style={{
                backgroundImage: `url(${images["portfolio12"]})`,
              }}
            ></div>
          </div>
          <div className="flex gap-3 flex-col lg:flex-row  py-3">
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio13"]})`,
              }}
            ></div>
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio14"]})`,
              }}
            ></div>
          </div>
          <div className="flex gap-3 flex-col lg:flex-row  py-3">
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio15"]})`,
              }}
            ></div>
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-top-center"
              style={{
                backgroundImage: `url(${images["portfolio16"]})`,
              }}
            ></div>
          </div>

          {/* Modal for displaying the clicked image */}
          {isModalOpen && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
              }}
              onClick={closeModal}
            >
              <img
                src={selectedImage}
                alt="Modal"
                style={{ maxWidth: "90%", maxHeight: "90%" }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PurvaRaghav;
